import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRates = (resource, id, lotId) => {
  return axios.get(`/api/${resource}/${id}/setup/lots/${lotId}/rates`);
};

export const useRates = (resource, id, lotId, options = {}) => {
  return useQuery(
    `${resource}-${id}-setup-lots-${lotId}-rates`,
    () => getRates(resource, id, lotId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
